import React, { useState, useRef, useEffect } from "react";
import MuxPlayer from "@mux/mux-player-react";
import "./MuxCard.css";

const MuxCard = ({ playbackId }) => {
  const [isPlaying, setIsPlaying] = useState(false);
  const [isMuted, setIsMuted] = useState(true);
  const playerRef = useRef(null);

  useEffect(() => {
    setIsPlaying(false);
    setIsMuted(true);
  }, [playbackId]);

  const togglePlayPause = () => {
    const player = playerRef.current;
    if (player?.media?.nativeEl) {
      const vid = player.media.nativeEl;
      if (vid.paused) {
        vid.muted = false;
        setIsMuted(false);
        vid.play().catch(() => {});
        setIsPlaying(true);
      } else {
        vid.pause();
        // vid.currentTime = 0; // Don't reset to beginning
        setIsPlaying(false);
      }
    }
  };

  const toggleMute = () => {
    const player = playerRef.current;
    if (player?.media?.nativeEl) {
      const vid = player.media.nativeEl;
      const newMutedState = !vid.muted;
      vid.muted = newMutedState;
      setIsMuted(newMutedState);
    }
  };

  const handleCardClick = () => {
    togglePlayPause();
  };

  return (
    <div className="mux-card-container">
      <div className="mux-card-wrapper">
        <div
          className="mux-video-card"
          onClick={handleCardClick}
          role="button"
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              togglePlayPause();
            }
          }}
        >
          <MuxPlayer
            ref={playerRef}
            playbackId={playbackId}
            muted
            playsInline
            loop
            className="mux-peek-player"
            thumbnailTime={0}
            style={{
              "--media-object-fit": "cover",
              "--controls": "none",
            }}
          />
          {!isPlaying && (
            <div className="mux-animated-poster">
              <img
                src={`https://mux.jobpeeks.com/${playbackId}/animated.gif`}
                alt="Video preview"
              />
            </div>
          )}
          {isPlaying && (
            <button
              className="mux-mute-unmute-btn"
              onClick={(e) => {
                e.stopPropagation();
                toggleMute();
              }}
              aria-label={isMuted ? "Unmute video" : "Mute video"}
            >
              <i
                className={!isMuted ? "feather-volume-2" : "feather-volume-x"}
              ></i>
            </button>
          )}
          <button
            className="mux-play-pause-btn"
            onClick={(e) => {
              e.stopPropagation();
              togglePlayPause();
            }}
            aria-label={isPlaying ? "Pause video" : "Play video"}
          >
            <i className={`feather-${isPlaying ? "pause" : "play"}`}></i>
          </button>
        </div>
      </div>
    </div>
  );
};

export default MuxCard;
